
// Frontend
import htmlIcon from '../assets/images/skills/frontend/html.png';
import cssIcon from '../assets/images/skills/frontend/css.png';
import boostrapIcon from '../assets/images/skills/frontend/boostrap.png';
import javascriptIcon from '../assets/images/skills/frontend/javascipt.png';
import reactIcon from '../assets/images/skills/frontend/react.svg';
import nextIcon from '../assets/images/skills/frontend/next.png';
import materialuiIcon from '../assets/images/skills/frontend/materialui.png';

// Backend
import phpIcon from '../assets/images/skills/backend/PHP-logo.svg.png';
import pythonIcon from '../assets/images/skills/backend/python.svg';
import nodeIcon from '../assets/images/skills/backend/nodejs.svg';
import expressIcon from '../assets/images/skills/backend/express.png';
import mysqlIcon from '../assets/images/skills/backend/mysql.svg';
import sqlliteIcon from '../assets/images/skills/backend/sqllite.png';
import mongoIcon from '../assets/images/skills/backend/mongo-db.svg';

// Server
import cpanelIcon from '../assets/images/skills/server/cpanel.png';
import hostingerIcon from '../assets/images/skills/server/hostinger.png';
import digitaloceanIcon from '../assets/images/skills/server/digitalocean.png';
import awsIcon from '../assets/images/skills/server/aws.png';
import netlifyIcon from '../assets/images/skills/server/netlify-logo.png';

// Others
import wordpressIcon from '../assets/images/skills/others/wordpress.png';
import gitIcon from '../assets/images/skills/others/git.svg';
import githubIcon from '../assets/images/skills/others/GitHub.png';
import vscodeIcon from '../assets/images/skills/others/vscode.png';
import postmanIcon from '../assets/images/skills/others/postman.svg';
import figmaIcon from '../assets/images/skills/others/figma.svg';
import shopifyIcon from '../assets/images/skills/others/shopify.webp';
import wixIcon from '../assets/images/skills/others/wix.png';

// Work Experence
import SkydreamersLogo from '../assets/images/job/skydreamers.png';
import TechrowthLogo from '../assets/images/job/techrowth.jpg';
import ItdigiLogo from '../assets/images/job/it-digi.jpg';


// Education
import jainLogo from '../assets/images/edu/jain-univercity.png';
import raisoniLogo from '../assets/images/edu/raisoni.png';

// Projects

import todoProject from '../assets/images/projects/todo-app.png';
import izbweb from '../assets/images/projects/izbweb.png';
import ecommdashboardProject from '../assets/images/projects/e-commorce.png';
import qrcodeProject from '../assets/images/projects/qr-code-gen.png';
import slipstreamweb from '../assets/images/projects/slipstreamweb.png';
import validusProject from '../assets/images/projects/website-ui.png';


export const Bio = {
  name: "Mayur Patil",
  roles: [
    "Full Stack Developer",
    "Web Application Dev",
    "SEO specialist",
    "Tech Enthusiast",
  ],
  description:
    "As a full stack developer, I have expertise in both front-end and back-end development, making me capable of handling a variety of tasks related to web development.",
  github: "https://github.com/Mark-218",
  resume:
    "https://drive.google.com/file/d/1Ue_P3VnvFh52403-92AEzYkWz7udUaGL/view?usp=drive_link",
  linkedin: "https://www.linkedin.com/in/mayurpatil218/",
  twitter: "https://twitter.com/Mayurpatil218",
  insta: "https://www.instagram.com/mayurpatil_10_/",
  facebook: "https://www.facebook.com/patil.mayur.501598",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "HTML",
        image: htmlIcon,
      },
      {
        name: "CSS",
        image: cssIcon,
      },
      {
        name: "JavaScript",
        image: javascriptIcon,
      },
     
     
      {
        name: "React Js",
        image: reactIcon,
      },
      {
        name: "Next Js",
        image: nextIcon,
      },
      {
        name: "Bootstrap",
        image: boostrapIcon,
      },
      {
        name: "Material UI",
        image: materialuiIcon,
      },

    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "PHP",
        image: phpIcon,
      },
  
      {
        name: "Node Js",
        image: nodeIcon,
      },  
      {
        name: "Express Js",
        image: expressIcon,
      },
      {
        name: "Django",
        image: pythonIcon ,
      },
      {
        name: "SQLite",
        image: sqlliteIcon ,
      },
      {
        name: "MySQL",
        image: mysqlIcon,
      },
      {
        name: "MongoDB",
        image: mongoIcon,
      },

    ],
  },
  {
    title: "Deployment",
    skills: [
      {
        name: "cPanel Hosting",
        image: cpanelIcon,
      },
      {
        name: "Hostinger",
        image: hostingerIcon,
      },
      {
        name: "Digitalocian",
        image: digitaloceanIcon,
      },
      {
        name: "Netlify",
        image: netlifyIcon,
      },
      {
        name: "Amazon Web Services",
        image: awsIcon,
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Wordpress",
        image: wordpressIcon,
      },
      {
        name: "Shopify",
        image: shopifyIcon,
      },
      {
        name: "Wix",
        image: wixIcon,
      },
      {
        name: "Git",
        image: gitIcon,
      },
      {
        name: "GitHub",
        image: githubIcon,
      },
      {
        name: "VS Code",
        image: vscodeIcon,
      },
      {
        name: "Postman",
        image: postmanIcon,
      },
      {
        name: "Figma",
        image: figmaIcon,
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: SkydreamersLogo,
    role: "Front-End Developer",
    company: "Sky Dreamers Club",
    date: "June 2024 – Present",
    location: "Mumbai, India",
    desc: "Lead Front-End Developer at Sky Dreamers Club, specializing in scalable web solutions using React.js, Next.js, Shopify Liquid, and WordPress. Leading the development team and collaborating with designers, the SEO team, and different departments to deliver high-performance, SEO-optimized, and mobile-friendly web experiences.",    skills: [
      "React.js",
      "Next.js",
      "Node.js",
      "Express.js",
      "MongoDB",
      "Shopify Liquid",
      "Figma to React.js/Next.js",
      "WordPress",
      "WooCommerce",
      "MySQL",
      "Web Application Development",
      "Website Deployment",
      "Bootstrap5",
      "PhpMyAdmin",
      "Front-End Development",
    
    ],

    // doc: "doc url",
},
  {
    id: 0,
    img: TechrowthLogo ,
    role: "Web Developer",
    company: "Techrowth Pvt. Ltd.",
    date: "May 2022 - June 2024",
    desc: "Web Developer at Techrowth Pvt. Ltd., specializing in front-end and back-end development. Proficient in Figma to HTML conversion, WordPress, MySQL, and PHP. Skilled in deploying websites, integrating payment gateways, and using React.js to create dynamic web experiences. Experienced in WooCommerce for e-commerce solutions and Bootstrap 5 for responsive design.",
    skills: [
      "Figma to HTML",
      "WordPress",
      "MySQL",
      "Web Application Development",
      "Website Deployment",
      "Bootstrap5",
      "PhpMyAdmin",
      "WooCommerce",
      "Front-End Development",
      "PHP",
      "React.js",
      "Payment Gateway",
    ],
    // doc: "doc url",
  },
  {
    id: 1,
    img: ItdigiLogo,
    role: "Web Application Developer",
    company: "IT Digi Solutions",
    date: "Sep 2021 - May 2022",
    desc: "Web Application Developer at IT Digi Solutions, specializing in creating robust web applications. Proficient in HTML5, CSS3, Bootstrap 5 for responsive design, and Python for backend development. Skilled in Django and Django REST Framework for building scalable web applications, and experienced in data analysis using PyTorch, NumPy, Pandas, and Celery for background task processing.",
    skills: [
      "Web Application Development",
      "HTML5",
      "CSS3",
      "Boostrap5",
      "Python",
      "Django",
      "Django REST Framework",
      "PyTorch",
      "NumPy",
      "Pandas",
      "Celery",
    ],
  },

];

export const education = [
  {
    id: 0,
    img: jainLogo,
    school: "Jain (Deemed-to-be University)",
    date: "Jul 2022 - Jul 2024",
    grade: "7.8 CGPA",
    desc: "Successfully completed a Master of Computer Applications (MCA) at Jain (Deemed-to-be-University). Gained advanced knowledge and skills in computer science, preparing to contribute effectively to the tech industry.",
    degree: "Master of Computer Applications - MCA",
},
  {
    id: 1,
    img: raisoniLogo,
    school: " G. H. Raisoni Institute of Business and Management, Jalgaon",
    date: "Jul 2019 - Jul 2022",
    grade: "10 CGPA",
    desc: "Completed Bachelor of Computer Applications (BCA) at G. H. Raisoni Institute of Business and Management, Jalgaon, to build a strong foundation in computer science and technology.",
    degree: "Bachelor of Computer Applications - BCA",
  },
];

export const projects = [


  {
    id: 3,
    title: "Indo Zambia Bank",
    date: "Jun 2023 - Nov 2023",
    description:
      "Upgraded the Indo Zambia Bank website from WordPress to React.js, enhancing performance, security, and user experience. Implemented a modern tech stack to create a faster, feature-rich banking platform. Indo Zambia Bank, established on 19th October 1984, is a collaboration between the Government of Zambia and the Government of India to promote banking services for economic development.",
    image: izbweb,
    tags: ["React.js", "EmailJS", "Figma to React", "CSS3", "JavaScript"],
    category: "Websites",
    webapp: "https://www.izb.co.zm/",
},


  {
    id: 9,
    title: "Todo App",
    date: "Jun 2023 - Jul 2023",
    description:
      "The Todo project is a valuable tool designed to help individuals efficiently manage their daily tasks. In an increasingly fast-paced world, staying organized is crucial, and this project offers a simple yet effective solution. Users can easily input their daily tasks, set priorities, deadlines, and even categorize them for better organization. With its user-friendly interface and intuitive features, the Todo project ensures that no task is forgotten or left undone. Whether you're a student juggling assignments, a professional managing work projects, or simply someone looking to enhance daily productivity, this project is your go-to companion. Stay on top of your responsibilities, reduce stress, and achieve your goals with the Todo project's seamless task management capabilities.",
    image: todoProject,
    tags: [
      "HTML5",
      "CSS3",
      "React Js",
      "Netlify",
    ],
    category: "Tools",
    webapp: "https://mayur-todo.netlify.app/",
  },
  {
    id: 0,
    title: "E-commerce Admin Panel",
    date: "Apr 2023 - Jun 2023",
    description:
      "The E-commerce Admin Panel is an indispensable tool for businesses operating in the digital marketplace. With the ever-expanding world of online commerce, businesses need a robust platform to manage their operations efficiently. This admin panel offers a comprehensive suite of features, enabling businesses to oversee inventory, track sales, and monitor customer interactions seamlessly. It provides real-time insights into website traffic, sales trends, and customer behavior, empowering businesses to make data-driven decisions. Moreover, the E-commerce Admin Panel simplifies the process of adding or updating products, managing pricing, and handling customer inquiries, ensuring a smooth and responsive online shopping experience. Whether you're a small startup or a well-established e-commerce giant, this admin panel is your gateway to success in the dynamic world of online retail. Stay in control of your e-commerce operations and elevate your business to new heights with the E-commerce Admin Panel.",
    image: ecommdashboardProject,
    tags: ["HTML5", "CSS3", "Boostrap5", "JavaScript", "PHP", "XAMPP"],
    category: "web app",
    // member: [
    //   {
    //     name: "Mayur Patil",
    //     img: "https://avatars.githubusercontent.com/u/64485885?v=4",
    //     linkedin: "https://www.linkedin.com/in/rishav-chanda-b89a791b3/",
    //     github: "https://github.com/rishavchanda/",
    //   },
    //   {
    //     name: "Upasana Chaudhuri",
    //     img: "https://avatars.githubusercontent.com/u/100614635?v=4",
    //     linkedin: "https://www.linkedin.com/in/upasana-chaudhuri-2a2bb5231/",
    //     github: "https://github.com/upasana0710",
    //   },
    // ],
  },

 

  {
    id: 3,
    title: "Validus Thailand",
    date: "Jun 2022 - Present",
    description:
      "Validus Thailand is an online shopping platform dedicated to education products and resources, serving the Thai market. It offers a wide range of educational materials, from textbooks and study aids to teaching tools and classroom supplies, catering to the needs of students, educators, and institutions in Thailand. With a user-friendly interface and a diverse product selection, Validus Thailand provides a convenient and comprehensive shopping experience for those seeking educational materials and resources in the region.",
    image: validusProject,
    tags: ["HTML5", "CSS3", "Boostrap5", "JavaScript", "Wordpress", "WooCommerce"],
    category: "Websites",
    webapp: "https://validusthailand.com/",
  },

  {
    id: 3,
    title: "QR code Generator",
    date: "May 2023",
    description:
      "A QR code generator is a versatile tool that simplifies the creation of Quick Response (QR) codes. These codes are essential in today's digital world, serving multiple purposes across various industries. With a QR code generator, you can quickly and effortlessly generate QR codes for websites, contact information, product details, event promotions, and more. Simply input the desired data, and the generator will create a scannable QR code that can be printed or shared digitally. It's an invaluable tool for businesses, marketers, and individuals seeking to enhance user engagement and seamlessly share information in a visually appealing and efficient manner.",
    image: qrcodeProject,
    tags: ["HTML5", "CSS3", "JavaScript"],
    category: "Tools",
    webapp: "https://mark-218.github.io/qr-code-generator/",
  },



  {
    id: 1,
    title: "Slipstream Automotive",
    date: "Oct 2024 - Nov 2024",
    description:
      "Designed and developed the Slipstream Automotive website using WordPress and Elementor. Created a visually appealing and responsive interface to showcase automotive services, product listings, and seamless service booking. The project enhances online presence and provides an intuitive experience for customers.",
    image: slipstreamweb,
    tags: [
      "WordPress",
      "Elementor",
      "WooCommerce",
      "PHP",
      "CSS",
      "JavaScript"
    ],
    category: "web app",
    webapp: "https://slipstreamautomotivedxb.com/",
 },

];

// export const TimeLineData = [
//   { year: 2017, text: "Started my journey" },
//   { year: 2018, text: "Worked as a freelance developer" },
//   { year: 2019, text: "Founded JavaScript Mastery" },
//   { year: 2020, text: "Shared my projects with the world" },
//   { year: 2021, text: "Started my own platform" },
// ];
